/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

const versionComparer = (versionToCheck: string, versionToCompareAgainst: string) => {
    const value = Math.sign(versionToCheck.localeCompare(versionToCompareAgainst, undefined, { numeric: true, sensitivity: 'base' }));
    return value;
};

export const versionGt = (versionToCheck: string, versionToCompareAgainst: string) => {
    const result = versionComparer(versionToCheck, versionToCompareAgainst);
    return result === 1 ? true : false;
};

export const versionLt = (versionToCheck: string, versionToCompareAgainst: string) => {
    const result = versionComparer(versionToCheck, versionToCompareAgainst);
    return result === -1 ? true : false;
};

export const versionGte = (versionToCheck: string, versionToCompareAgainst: string) => {
    const result = versionComparer(versionToCheck, versionToCompareAgainst);
    return result === 1 || result === 0 ? true : false;
};

export const versionLte = (versionToCheck: string, versionToCompareAgainst: string) => {
    const result = versionComparer(versionToCheck, versionToCompareAgainst);
    return result === -1 || result === 0 ? true : false;
};
